import React from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RefundablePaymentData } from '../api';
import { UseAuthPermissions } from '../session/UseAuthPermissions';
import { ReactComponent as RefundIcon } from '../images/refundIcons/mb-refund.svg';

type RefundIconButtonProps = {
  item?: RefundablePaymentData;
  onRefund: (item: RefundablePaymentData) => void;
};

export const RefundIconButton = ({ item, onRefund }: RefundIconButtonProps) => {
  const { t } = useTranslation();
  const { readOnly } = UseAuthPermissions();

  if (!item) {
    return null;
  }

  const disabledReason = readOnly
    ? t('noPermissions')
    : item.disabled_reason
    ? t(`refunds.disabled.${item.disabled_reason}`)
    : '';

  if (disabledReason) {
    return (
      <Tooltip enterTouchDelay={0} title={disabledReason} arrow>
        <Grid component="span" display="inline-flex">
          <IconButton
            size="small"
            aria-disabled
            aria-label={t('refunds.action')}
            sx={{ opacity: 0.35 }}
            onClick={(event) => event.preventDefault()}>
            <RefundIcon width={24} height={24} />
          </IconButton>
        </Grid>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('refunds.action')} arrow>
      <IconButton size="small" aria-label={t('refunds.action')} onClick={() => onRefund(item)}>
        <RefundIcon width={24} height={24} />
      </IconButton>
    </Tooltip>
  );
};
